"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

require("moment/locale/nb");

require("moment/locale/nn");

require("moment/locale/sv");

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Akkurat, sans-serif",
    fontSize: "12px",
    margin: theme.spacing(1)
  },
  status: {
    display: "inline",
    fontWeight: "bold",
    "&[data-status=error]": {
      color: theme.palette.error.main
    }
  },
  message: {
    display: "inline",
    marginLeft: theme.spacing(1),
    "&[data-status=error]": {
      color: theme.palette.error.main
    }
  },
  datetime: {
    display: "inline",
    marginLeft: theme.spacing(1)
  }
}));
const statusLabels = {
  "new": "Ny",
  "draft": "Utkast",
  "publish": "Publisert",
  "error": "Feil"
};

const StatusLabel = ({
  className,
  locale = "nb",
  status,
  children
}) => {
  const classes = useStyles();
  const statusLabel = children || statusLabels[status] || status;
  return _react.default.createElement("span", {
    className: className || classes.status,
    "data-status": status
  }, statusLabel);
};

const StatusDate = ({
  className,
  locale = "nb",
  format = "relative",
  datetime,
  children
}) => {
  const classes = useStyles();
  datetime = children || datetime;

  if (!datetime) {
    return false;
  } // format value


  _moment.default.locale(locale);

  let date;

  if (format === "relative") {
    date = _moment.default.utc(datetime).local().fromNow();
  } else if (format) {
    date = _moment.default.utc(datetime).local().format(format);
  }

  return _react.default.createElement("time", {
    datetime: datetime,
    className: className || classes.datetime
  }, date);
};

const StatusMessage = ({
  className,
  status,
  code,
  children
}) => {
  const classes = useStyles();

  if (!children) {
    return false;
  }

  return _react.default.createElement("span", {
    "data-status": status,
    "data-code": code,
    className: className || classes.message
  }, children);
};

const EditorStatus = ({
  className,
  status,
  statusLabel,
  statusDate,
  statusCode,
  statusMessage
}) => {
  const classes = useStyles();
  return _react.default.createElement(_Typography.default, {
    className: className || classes.root,
    noWrap: true
  }, _react.default.createElement(StatusLabel, {
    className: classes.status,
    status: status
  }, statusLabel), _react.default.createElement(StatusMessage, {
    className: classes.message,
    status: status,
    code: statusCode
  }, statusMessage), !statusMessage && _react.default.createElement(StatusDate, {
    className: classes.datetime
  }, statusDate));
};

var _default = EditorStatus;
exports.default = _default;
module.exports = exports.default;